import React, { useContext } from 'react';
import Client from 'shopify-buy';
import {CartContext, CheckoutsContext} from "./products/productsContext"

const client = Client.buildClient({
  domain: 'conecuh-brands.myshopify.com',
  storefrontAccessToken: 'fd73aae121a8110089143a1d450c7b6e'
});


const Cart = (props) => {
  // eslint-disable-next-line 
  const [showCart, setShowCart] = useContext(CartContext)
  const [checkout, setCheckout] = useContext(CheckoutsContext)

  const addVariantToCart = (variantId, quantity) => {
    setShowCart(true)
    if(!props.isDetailPage){
      props.closeModal()
    }
    
    const lineItemsToAdd = [{variantId, quantity: parseInt(quantity, 10)}]
    const checkoutId = checkout.id
    client.checkout.addLineItems(checkoutId, lineItemsToAdd).then(res => {
       setCheckout(res)
    });
  }

  console.log(props.variant_id, props.variantQuantity)

  return(
      <button className="add-to-cart btn btn-default" type="button" onClick={() => addVariantToCart(props.variant_id, props.variantQuantity)}>ADD TO CART</button>
  ); 
}

export default Cart;



// WEBPACK FOOTER //
// ./src/components/Cart.js